'use strict';

var React = require('react');

var SvgFirstVisitMajor = function SvgFirstVisitMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m8.8 8.69.7-.3v3.11h-1a.75.75 0 0 0 0 1.5h3.5a.75.75 0 0 0 0-1.5h-1v-3.5c0-.89-.92-1.5-1.74-1.14l-1.06.44a.75.75 0 0 0 .6 1.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10 4a7.63 7.63 0 0 0-5.58 2.53 9.27 9.27 0 0 0-1.77 2.74c-.08.23-.15.49-.15.73s.07.5.15.73c.09.24.21.52.37.82.32.58.79 1.27 1.4 1.92a7.63 7.63 0 0 0 5.58 2.53 7.63 7.63 0 0 0 5.58-2.53 9.26 9.26 0 0 0 1.77-2.74c.08-.23.15-.49.15-.73s-.07-.5-.15-.73a9.27 9.27 0 0 0-1.77-2.74 7.63 7.63 0 0 0-5.58-2.53Zm-6 6 .07-.23a7.77 7.77 0 0 1 1.45-2.21 6.14 6.14 0 0 1 4.48-2.06c1.94 0 3.44.96 4.49 2.06a7.77 7.77 0 0 1 1.44 2.21l.07.23-.07.23a7.77 7.77 0 0 1-1.45 2.21 6.14 6.14 0 0 1-4.48 2.06 6.14 6.14 0 0 1-4.49-2.06 7.77 7.77 0 0 1-1.44-2.21l-.07-.23Z"
  }));
};
SvgFirstVisitMajor.displayName = "FirstVisitMajor";

exports.SvgFirstVisitMajor = SvgFirstVisitMajor;
